"use strict";

exports.__esModule = true;
exports.AdvancedTimelineContext = void 0;
var _Utils = require("../../../Utils");
var _AdvancedTimelineController = require("./AdvancedTimelineController");
/**
 * Provides a rest api to consumers.
 * @component
 */
var AdvancedTimelineContext = exports.AdvancedTimelineContext = (0, _Utils.createEnhancedContext)({
  propName: "timelines",
  defaultController: _AdvancedTimelineController.AdvancedTimelineController
});